/* oxlint-disable react/jsx-no-target-blank */
import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './MainTitle.css';
import { trackTitleClick } from './trackings';
import { IPageState } from '../../types/page';
import { IFavoriteEntity } from '../../types/results';
import { TUser } from '../../types/user';
import { Text } from '../Text';

export interface IMainTitleStoreProps {
  page: IPageState;
  user: TUser;
  total: number;
  favoriteEntities: IFavoriteEntity[];
}

export interface IMainTitleOwnProps {
  title: string;
  fullUrl: string;
  entityId: number;
  isNewbuilding?: boolean;
}

export type TMainTitleProps = IMainTitleStoreProps & IMainTitleOwnProps;

export function MainTitle(props: TMainTitleProps) {
  const { title, fullUrl, entityId, favoriteEntities, page, user, total, isNewbuilding } = props;

  const link = (
    <a
      href={fullUrl}
      target="_blank"
      data-testid="MainTitle"
      onClick={() => {
        trackTitleClick(page, user, entityId, favoriteEntities, total);
      }}
    >
      {title}
    </a>
  );

  return (
    <div className={styles['container']}>
      {isNewbuilding ? (
        <UIHeading2>{link}</UIHeading2>
      ) : (
        <Text color="blue" bold={true}>
          {link}
        </Text>
      )}
    </div>
  );
}
